import {
    GET_SALES_ORDER_LIST_PROGRESS, GET_SALES_ORDER_LIST_SUCCESS, GET_SALES_ORDER_LIST_FAILURE,
    ADD_SALES_ORDER_PROGRESS, ADD_SALES_ORDER_SUCCESS, ADD_SALES_ORDER_FAILURE,
    EDIT_DELETE_SALES_ORDER_PROGRESS, EDIT_DELETE_SALES_ORDER_SUCCESS, EDIT_DELETE_SALES_ORDER_FAILURE,

    RESET_MESSAGE,
    GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS,
    GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE,
    GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS,

} from '../../types/actionTypes';

const initialState = {
    salesOrder: [],
    lastEntryNo:null,
    salesOrder_itemDescription_forManualEntry: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const sales_order_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SALES_ORDER_LIST_SUCCESS:
            return { ...state, salesOrder: action.salesOrder, lastEntryNo: action.salesOrder[0].salesOrderNo, loading: false };
        case GET_SALES_ORDER_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_SALES_ORDER_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_SALES_ORDER_PROGRESS:
            return { ...state, loading: true };
        case ADD_SALES_ORDER_SUCCESS:
            return { ...state, salesOrder: [...state.salesOrder, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_SALES_ORDER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_SALES_ORDER_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_SALES_ORDER_SUCCESS:
            return {
                ...state,
                salesOrder: state.salesOrder.map((salesOrder) =>
                    salesOrder.id === action.payload.id ? action.payload : salesOrder
                ),
                message: action.payload.message,
            };
        case EDIT_DELETE_SALES_ORDER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS:
            return { ...state, salesOrder_itemDescription_forManualEntry: action.salesOrder_itemDescription_forManualEntry, loading: false };
        case GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS:
            return { ...state, loading: true, error: false };

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default sales_order_reducer;